// extracted by mini-css-extract-plugin
export default {"wrapper":"SectionHeading_wrapper__b7UZI","hr":"SectionHeading_hr__kDeoy"};